import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=b996bd8c&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"
import style0 from "./Community.vue?vue&type=style&index=0&id=b996bd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b996bd8c",
  null
  
)

export default component.exports